import { CRAWLER_TYPES, CrawlerType } from '~features/crawler-filter';

const TOOLTIPS: Partial<Record<CrawlerType, string>> = {
  [CRAWLER_TYPES.Other]:
    'Includes thousands of lesser-known crawlers and bots, with each contributing less than <strong>0.5% of total traffic</strong>. To keep things simple, we group them here.',
};

export default TOOLTIPS;
